// Builds the PUT /settings payload from the Company Info / System form state.
// Empty strings are dropped so untouched fields are not overwritten, EXCEPT the
// company-role references (owner/supervisor/lead), which are always included as
// their value or null so that choosing "Unassigned" reliably clears them.
export const ROLE_FIELDS = ['owner_user_id', 'supervisor_user_id', 'lead_user_id'];

export function buildSettingsPayload(formData) {
  const payload = {};
  Object.keys(formData).forEach((key) => {
    if (ROLE_FIELDS.includes(key)) return; // handled explicitly below
    const value = formData[key];
    if (value !== '' && value !== undefined && value !== null) {
      payload[key] = value;
    }
  });
  ROLE_FIELDS.forEach((key) => {
    const value = formData[key];
    payload[key] = value ? value : null;
  });
  return payload;
}
